// extracted by mini-css-extract-plugin
export default {"tableCard":"TableCard_tableCard__4UhV2","cardHeader":"TableCard_cardHeader__T5At8","headerText":"TableCard_headerText__+f+dC","columnData":"TableCard_columnData__JvpW5"};